// +----------------------------------------------------------------------
// | Desc:导入全局配置
// +----------------------------------------------------------------------
import Vue from "vue";

// +----------------------------------------------------------------------
// | Desc: 国知局数据
// +----------------------------------------------------------------------
Vue.prototype.$getGZstc = function (applicationNumber, callback) {
  var that = this;
  var https = {
    type: "isApi",
    isLoading: "isLoadingPop",
    api: this.$api.getSFGzjStc,
    parameter: {
      applicationNumber: applicationNumber,
    },
  };
  this.$httpsApi(https, function (res) {
    callback && callback();
  });
};

// +----------------------------------------------------------------------
// | 实时在售专利数
// +----------------------------------------------------------------------
Vue.prototype.$calculateValue = function (that) {
  return "10万+";
  // 基数
  const base = 982541;
  // 当前时间的毫秒值
  const currentTime = Date.now();
  // 将毫秒值转换为秒
  const seconds = 1743706908 - Math.floor(currentTime / 1000);
  // 计算增量值
  const increment = Math.floor(seconds / 1000);
  // 计算最终值
  const finalValue = base + increment;
  return finalValue;
};

// +----------------------------------------------------------------------
// | 打开ifram前验证登录
// +----------------------------------------------------------------------
Vue.prototype.$QHopenUrlIsLogin = function (url) {
  var that = this;
  if (!this.$isLogin()) {
    this.$msg("请先登录");
    this.$emit("isLoginOut");
    return false;
  }
  this.$QHopen.url(url, 90, 90, function () {
    that.$getMYguanzhuzhuanli();
  });
};

// +----------------------------------------------------------------------
// | Desc:查询购物车信息
// +----------------------------------------------------------------------
Vue.prototype.$onOffGuanzhu = function (row, guanzhuStatus, event) {
  if (!this.$isLogin()) {
    this.$msg("请先登录", "error");
    this.$refs.layout.helloLoginPop();
    return;
  }
  //参数整合与接口
  var apiQX = this.$api.CGquxiaoGuanzhu;
  var apiGZ = this.$api.CGsetGuanzhu;

  //移入移除判定
  if (guanzhuStatus == "yiGuanzhu") {
    var api = apiQX;
  } else {
    api = apiGZ;
  }

  //请求接口
  var that = this;
  var https = {
    type: "isApi",
    isLoading: "isLoadingPop",
    api: api,
    parameter: {
      goods_id: row.id,
    },
  };
  that.$httpsApi(https, function (res) {
    if (guanzhuStatus == "yiGuanzhu") {
      //取消购物车
      that.$onOffGuanzhuStaticUpdate("quxiaoGuanzhu", row.id);
    } else {
      //添加购物车
      if (event) {
        that.$cartParabola(event, function () {
          that.$onOffGuanzhuStaticUpdate("addGuanzhu", row.id);
        });
      } else {
        that.$onOffGuanzhuStaticUpdate("addGuanzhu", row.id);
      }
    }
  });
};

// +----------------------------------------------------------------------
// | Desc:查找我购物车的专利
// +----------------------------------------------------------------------
Vue.prototype.$getMYguanzhuzhuanli = function () {
  var that = this;
  if (!this.$isLogin()) {
    var obj = {
      isGuanzhu: [],
      isGuanzhuNum: 0,
    };
    that.$store.commit("UPDATE_TOAST_CAR", obj || {});
    return;
  }
  //参数整合与接口
  var api = this.$api.CGgetMYguanzhuzhuanli;

  //请求接口
  var https = {
    type: "isApi",
    isLoading: "isApi",
    api: api,
  };
  that.$httpsApi(https, function (res) {
    if (res.code == 0) {
      var obj = {
        isGuanzhu: res.data.isGuanzhu,
        isGuanzhuNum: res.data.isGuanzhuNum,
      };
      that.$store.commit("UPDATE_TOAST_CAR", obj || {});
    } else {
      var obj = {
        isGuanzhu: [],
        isGuanzhuNum: 0,
      };
      that.$store.commit("UPDATE_TOAST_CAR", obj || {});
    }
  });
};

// +----------------------------------------------------------------------
// | Desc:购物车静态移入移除
// +----------------------------------------------------------------------
Vue.prototype.$onOffGuanzhuStaticUpdate = function (action, id) {
  const list = this.$store.state.carCount.isGuanzhu || [];
  if (action === "quxiaoGuanzhu") {
    const idx = list.indexOf(id);
    if (idx > -1) list.splice(idx, 1);
  } else if (action === "addGuanzhu" && !list.includes(id)) {
    list.push(id);
  }
  // 去重+去空+去非法
  var cleanList = [...new Set(list)].filter((v) => v != null && v !== "");
  var obj = {
    isGuanzhu: cleanList,
    isGuanzhuNum: cleanList.length,
  };
  this.$store.commit("UPDATE_TOAST_CAR", obj || {});
};

// +----------------------------------------------------------------------
// | Desc: 批量加入购物车
// +----------------------------------------------------------------------
Vue.prototype.$batchAddToCart = async function (ids) {
  var that = this;
  var isValidTableSelect = this.$isValidTableSelect(ids, 1, 100);
  if (!isValidTableSelect) {
    return;
  }
  const confirmSys = await this.$confirmSys({ title: "加入购物车确认", msg: "您确认要将选中的" + isValidTableSelect + "条数据加入购物车 ？" });
  if (!confirmSys) {
    return;
  }
  var https = {
    type: "isApi",
    isLoading: "isLoadingPop",
    api: that.$api.batchAddToCart,
    parameter: {
      ids: ids,
    },
    successMsg: "加入成功",
  };
  that.$httpsApi(https, function (res) {
    that.selectedRows = [];
    that.getList();
    that.$getMYguanzhuzhuanli();
  });
};

// +----------------------------------------------------------------------
// | Desc: 批量移除购物车
// +----------------------------------------------------------------------
Vue.prototype.$batchRemoveFromCart = async function (ids) {
  var that = this;
  var isValidTableSelect = this.$isValidTableSelect(ids, 1, 100);
  if (!isValidTableSelect) {
    return;
  }
  const confirmSys = await this.$confirmSys({ title: "批量移除购物车确认", msg: "您确认要将选中的" + isValidTableSelect + "条数据移除购物车 ？" });
  if (!confirmSys) {
    return;
  }
  var https = {
    type: "isApi",
    isLoading: "isLoadingPop",
    api: that.$api.batchRemoveFromCart,
    parameter: {
      ids: ids,
    },
    successMsg: "移除成功",
  };
  that.$httpsApi(https, function (res) {
    that.selectedRows = [];
    that.getList();
    that.$getMYguanzhuzhuanli();
  });
};

// +----------------------------------------------------------------------
// | Desc: 清空购物车
// +----------------------------------------------------------------------
Vue.prototype.$batchMoveToCart = async function () {
  var that = this;
  const confirmSys = await this.$confirmSys({ title: "清空购物车提示", msg: "您确认要清空购物车吗 ？" });
  if (!confirmSys) {
    return;
  }
  var https = {
    type: "isApi",
    isLoading: "isLoadingPop",
    api: that.$api.batchMoveToCart,
    parameter: {},
    successMsg: "清空成功",
  };
  that.$httpsApi(https, function (res) {
    that.selectedRows = [];
    that.getList();
    that.$getMYguanzhuzhuanli();
  });
};
